const initialApplicationState = {
  user: {
    email: '',
    loaded: false
  },
};

const applicationReducer = function(state = initialApplicationState, action) {
  switch(action.type) {
    case 'FETCH_APPLICATION_SETTINGS_SUCCESS':
      action.payload['loaded'] = true;
      return Object.assign({}, state, action.payload);
  }

  return state;
};
export default applicationReducer;


// WEBPACK FOOTER //
// ./app/javascript/app/reducers/application.js